const getIncrementedUrlPath = (incrementalPath: string, basePath = location.pathname) => (
  `${basePath}/${incrementalPath}`.replace(/\/+/g, '/')
);

export default getIncrementedUrlPath;
